import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const NotificationBadge = ({ count, props }) => {
    return (
        <div className="relative w-10 h-10 flex items-center justify-center">
            {/* Ícone de notificação */}
            <NotificationsActiveIcon className="w-8 h-8 text-gray-600 dark:text-white" {...props} />

            {/* Badge de notificações */}
            {count > 0 && (
                <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full px-2 py-0.5">
                    {count > 99 ? "99+" : count}
                </span>
            )}
        </div>
    );
};

export default NotificationBadge;